import React from "react";
import { getLocalizedString } from "@icarius-localization/strings";
import CommonPage from "@icarius-common/commonPage";
import paths from "@icarius-router/paths";
import MenuItemWithIcon from "@icarius-common/MenuItemWithIcon";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import useTemplates from "@icarius-common/templates/components/useTemplates";
import TemplatesHeader from "@icarius-common/templates/components/templatesHeader";
import CreateTemplateDialog from "@icarius-common/templates/components/createTemplateDialog";
import useVacations from "./useVacations";
import EmployeeVacationsDialog from "./employeeVacationsDialog";
import GraphsDialog from "./graphsDialog";
import useIsSocietyCountry from "@icarius-app/components/wrapper/hooks/useIsSocietyCountry";
import useFixedFilters from "@icarius-common/fixedFilters";

const Vacations = () => {
    const title = getLocalizedString("vacationsTitleLong");
    const isPeru = useIsSocietyCountry("PE");

    const {
        isLoading,
        data,
        debitData,
        creditData,
        miscData,
        vacationsSchema,
        dateFormat,
        locale,
        state,
        handlers,
        contractDate,
        outcomeDate,
        vacationsUpdateDate,
    } = useVacations();

    const {
        user,
        templates,
        selectedTemplate,
        isLoadingTemplates,
        createTemplateDialogIsOpen,
        getRole,
        handleCreateTemplate,
        handleImportTemplates,
        handleExportTemplates,
        handleSelectTemplateAndUpdateGrid,
        handleOpenCreateTemplateDialog,
        handleOpenUpdateTemplateDialog,
        handleOpenDeleteTemplateDialog,
        handleCloseCreateTemplateDialog,
    } = useTemplates("VACATIONS");

    const { hasFixedFilters, toggleFixedFilters } = useFixedFilters(title);

    const customHeader = (gridRef) =>
        user.level === "E" && (
            <TemplatesHeader
                gridRef={gridRef}
                user={user}
                templates={templates}
                selectedTemplate={selectedTemplate}
                getRole={getRole}
                handleImportTemplates={handleImportTemplates}
                handleExportTemplates={handleExportTemplates}
                handleOpenCreateTemplateDialog={handleOpenCreateTemplateDialog}
                handleOpenDeleteTemplateDialog={handleOpenDeleteTemplateDialog}
                handleOpenUpdateTemplateDialog={handleOpenUpdateTemplateDialog}
                handleSelectTemplateAndUpdateGrid={handleSelectTemplateAndUpdateGrid}
            />
        );

    const mailItem = (gridRef) => (
        <CustomIconButton
            title={getLocalizedString("sendReminderMessage")}
            onClick={() => handlers.handleOpenMailDialog(gridRef)}
            type={"mail"}
        />
    );

    const graphicsItem = (gridRef) =>
        Boolean(data.length) && (
            <CustomIconButton
                title={getLocalizedString("charts")}
                onClick={() => handlers.handleOpenGraphs(gridRef)}
                type={"graphics"}
            />
        );

    const helpItems = [
        <MenuItemWithIcon
            key={"a"}
            value={"/resources/ICARIUS - Cuenta corriente de vacaciones.pdf"}
            text={getLocalizedString("ctaCteVacacionesInstructivo")}
            type={"file"}
        />,
    ];

    const child = (gridRef) => (
        <>
            {state.employeeVacationsDialogIsOpen && (
                <EmployeeVacationsDialog
                    open={state.employeeVacationsDialogIsOpen}
                    isLoading={isLoading}
                    creditData={creditData}
                    debitData={debitData}
                    miscData={miscData}
                    vacationsSchema={vacationsSchema}
                    employeeCode={state.selectedRow.code}
                    employeeName={state.selectedRow.name}
                    dateFormat={dateFormat}
                    handleClose={handlers.handleCloseSecondGrid}
                    vacationsUpdateDate={vacationsUpdateDate}
                    contractDate={contractDate}
                    outcomeDate={outcomeDate}
                />
            )}
            {state.graphsDialogIsOpen && (
                <GraphsDialog
                    open={state.graphsDialogIsOpen}
                    data={state.graphDialogData}
                    handleClose={handlers.handleCloseGraphs}
                />
            )}
            {createTemplateDialogIsOpen && (
                <CreateTemplateDialog
                    open={createTemplateDialogIsOpen}
                    level={user.level}
                    handleCreateTemplate={(role, name) => handleCreateTemplate(gridRef, role, name)}
                    handleCloseDialog={handleCloseCreateTemplateDialog}
                />
            )}
        </>
    );

    const filtersItem = (gridRef) => (
        <CustomIconButton
            title={hasFixedFilters ? getLocalizedString("removeFixedFilters") : getLocalizedString("setFixedFilters")}
            onClick={() => toggleFixedFilters(gridRef, Boolean(selectedTemplate))}
            type={"fixedFilter"}
            isSelected={hasFixedFilters}
        />
    );

    return (
        <CommonPage
            isLoading={isLoadingTemplates || isLoading}
            rowData={data}
            title={title}
            gridTitle={title}
            locale={locale}
            dateFormat={dateFormat}
            columnDefPage={isPeru ? "vacationsPE" : paths.vacations}
            handleRowClick={handlers.handleRowClick}
            hasHelp
            helpItems={helpItems}
            customHeader={customHeader}
            menuItems={[graphicsItem, mailItem, filtersItem]}
            handleOpenGraphs={handlers.handleOpenGraphs}
            hasExpand
            hasSelectAll
            codeFieldName={"code"}
            hasFixedFilters
        >
            {child}
        </CommonPage>
    );
};

export default Vacations;
